var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('treeselect',{ref:"treeselect",class:_vm.uniqueId +
      ' ' +
      _vm.customClass +
      (_vm.hideOptions ? 'hide-options-treeselect' : ''),attrs:{"options":_vm.options,"searchable":true,"noResultsText":"موردی یافت نشد","multiple":true,"noOptionsText":"موردی وجود ندارد","placeholder":_vm.placeholder},on:{"select":_vm.selected},scopedSlots:_vm._u([{key:"value-label",fn:function(ref){
      var node = ref.node;
return _c('div',{},[_vm._v(_vm._s(node.label))])}}]),model:{value:(_vm.realValue),callback:function ($$v) {_vm.realValue=$$v},expression:"realValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }